<template>
    <div class="bill-detail-page parent-frame" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <Breadcrumb />
        <div class="tool-bar-mask"></div>
        <div class="bill-detail-page-head">
            <h1>{{houseName}}</h1>
            <div class="address">
                <img src="../../../assets/img/icon/address_gray.svg" alt="">
                {{houseAddress}}
            </div>
        </div>
        
        <bill-detail-comp @houseDetail="setHouseDetail"></bill-detail-comp>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import billDetailComp from '@/components/landlord/leaseManagement/billDetailComp.vue'

export default {
    data () {
        return {
            listIsFixed: false,
            myHeight: (window.innerHeight) + 'px',
            houseName: null,
            houseAddress: null,
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        setHouseDetail: function (val) {
            console.log(val)
            this.houseName = val.houseName
            this.houseAddress = val.houseAddress
        }
    },
    components: {
        Breadcrumb,
        billDetailComp
    }
}
</script>
<style lang="scss" scoped>
    .bill-detail-page{
        position: relative;
        margin-top: 80px;
        margin-bottom: 100px;
        .bill-detail-page-head{
            display: flex;
            justify-content: space-between;
            h1{
                margin-top: 25px;
                margin-bottom: 30px;
            }
            .address{
                position: relative;
                display: flex;
                align-items: center;
                right: 20px;
                img{
                    margin-right: 2px;
                }
            }
        }
        
    }
    .bill-detail-page.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        .bill-detail-page-head{
            position: fixed;
            top: -3px;
            z-index: 8;
            width: 1175px;
            .address{
                right: 30px;
            }
        }
        .bill-detail{
            border-radius: 0 0 10px 10px;
            .mask{
                position: fixed;
                background: #f6f6f6;
                width: 1190px;
                height: 50px;
                top: 81px;
                margin-left: -15px;
                z-index: 9;
            }
            .table-list-title{
                position: fixed;
                background: #fff;
                top: 96px;
                border-radius: 10px 10px 0 0 ;
                z-index: 9;
            }
        
        }
    }
    @media screen and (max-width: 1280px) {
        .bill-detail-page.fixed{
            .tool-bar-mask{
                margin-left: -24px;
            }
            .bill-detail-page-head{
                position: fixed;
                top: -3px;
                z-index: 8;
                width: 1154px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/LeaseManagementPages/BillDetail.vue